import Toast from 'vant/lib/toast'
/* 常用正则 */
export const PATTERN = {
  USER_NAME: {
    rule: /^([\u4e00-\u9fa5]{2,10}|[a-zA-Z]{2,10})$|^(?=.*[\u4e00-\u9fa5])(?=.*\d)[\u4e00-\u9fa5\d]{2,10}$'/,
    message: '用户名格式为中文+数字或者纯英文'
  },
  IDENTITY_CARD: {
    rule: /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])$|^([1−9]\d5\d2((0[1−9])|(10|11|12))(([0−2][1−9])|10|20|30|31)\d2[0−9Xx])$/,
    message: '身份证格式有误'
  },
  TEL: {
    rule: /^[1][0-9]{10}$/,
    message: '手机号码格式不正确'
  },
  SMS: {
    rule: /[A-Za-z0-9]{4,}/,
    message: '短信验证码格式不正确'
  },
  PASSWORD: {
    rule: /[A-Za-z0-9]{6,}/,
    message: '密码长度不正确'
  },
  REQUIRE: {
    rule: /^\s*$/g,
    message: '不能为空'
  }
}
/* location跳转 */
export const Location = function (url, isReplace) {
  Toast.loading({
    mask: true,
    duration: 2000,
    message: '跳转中...'
  })
  if (isReplace) {
    window.location.replace(url)
  } else {
    let oldUrl = url
    if (/html\?/.test(oldUrl)) {
      oldUrl = oldUrl.replace(/html\?/, 'html?versions=old&')
    } else if (/html/.test(oldUrl)) {
      oldUrl = oldUrl.replace(/html/, 'html?versions=old')
    }
    window.location.href = oldUrl
  }
  // locationToast.clear({mask: false})
  // locationToast.close()
}

/* 加载动画 */
export const Loading = {
  show (params) {
    let options = {
      mask: true,
      duration: 0,
      message: '加载中...'
    }
    Object.assign(options, params)
    Toast.loading(options)
  },
  close () {
    Toast.clear()
  }
}

export const ToastMessage = function (content) {
  Toast.clear()
  Toast({
    type: 'html',
    duration: 4000, // 持续展示toast 4s
    message: `<i class="icon icon-note margin-r-5"></i>${content}`
  })
}

/* 获取location中的url参数 */
export const getQuery = function (name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

export const uuid = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export const encryption = {
  encryptNUM (num) {
    let str = ''
    if ((num + '')) {
      (num + '').split('').forEach(obj => { str += String.fromCharCode((obj.charCodeAt()) + 17) })
    }
    return str
  },
  decode (num) {
    let str = ''
    if (num) {
      num.split('').forEach(obj => { str += String.fromCharCode(obj.charCodeAt(num) - 17) })
    }
    return str
  }
}

export const isiOS = function () {
  var u = navigator.userAgent
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  return isiOS
}

export const copy = function (data) {
  let copyData
  if (typeof data === 'object') {
    copyData = JSON.stringify(data)
    copyData = JSON.parse(copyData)
  } else {
    copyData = data
  }
  return copyData
}

export const IDCardMsg = function (ID) {
  var NOW_Date = new Date()
  var year = NOW_Date.getFullYear()
  let age = year - parseInt(ID.substring(6, 10))
  let birthday = `${year}/${ID.substring(10, 12)}/${ID.substring(12, 14)}`
  if (new Date(birthday).getTime() > new Date().getTime()) {
    age -= 1
  }
  let sexCode = parseInt(ID.substring(16, 17)) % 2 === 0 ? 'female' : 'male'
  return {age: age, sexCode: sexCode}
}
